import { render, staticRenderFns } from "./InplayCart.vue?vue&type=template&id=2c0ad45a&scoped=true"
import script from "./InplayCart.vue?vue&type=script&lang=js"
export * from "./InplayCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0ad45a",
  null
  
)

export default component.exports